export default __webpack_public_path__ + "3229a6f7b5b17754b0444301fe6d25fb.svg";